import React, {memo, useCallback, useState} from "react"
import {PasswordContainer} from "../../../../../components/PasswordContainer"
import {useHistory} from "react-router-dom"
import "./index.scss"

export const ColorTestScreen = memo(function ColorTestScreen() {
    const [selectedColor, setSelectedColor] = useState<string>("black")
    const [order, setOrder] = useState(0)
    const history = useHistory()

    const changeColor = useCallback(() => {
        let i = order
        if (i >= 0) {
            i++
            if (i === 5) {
                i = 0
            }
        }
        setOrder(i)
        let color = selectedColor
        switch (i) {
            case 0:
                color = "black"
                break
            case 1:
                color = "red"
                break
            case 2:
                color = "blue"
                break
            case 3:
                color = "white"
                break
            case 4:
                color = "green"
                break
            default:
                color = "black"
                break
        }
        setSelectedColor(color)
    }, [order, selectedColor])
    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <div
                className="test-color-container"
                onDoubleClick={() => history.push("/settings/advanced-settings/test")}
            >
                <div className="test-color-bg" style={{backgroundColor: selectedColor}} onClick={changeColor}></div>
            </div>
        </PasswordContainer>
    )
})
